
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableFooter,
    TableRow,
    TablePagination,
    Button,
    Drawer,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        ListViewColumnFactory,
        ListViewFilterModel,
        RecordModel} from '../../models/models';
import {PlotlyChartFigure} from "../../models/modelsDashboard";
import {ListViewUIPreferenceModel,
        ListViewUIPreferenceJSON,
        SortOrderModel,
        SortOrderFactory,
        SortDirectionType,
        BarChartUIPreferenceModel} from '../../models/modelsUserConfiguration';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {CustomIconComponent} from "../../components/icons/CustomIcon";
import {ListFilterComponent} from "./ListFilter";
import {ListConfigurationComponent} from "./ListConfiguration";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import FilterListIcon from '@mui/icons-material/FilterList';
import {upsertListView} from "../../services/metadataApi";
import { useAuth } from "../../hooks/useAuth";
import Plot from 'react-plotly.js'


export const BarChartViewComponent: React.FC<{
  chart: PlotlyChartFigure,
}> = ({
  chart,
}) => {

  const columnAlignment = 'left'

  const styles = ContainerClasses();

  const {accessToken, onInvalidToken} = useAuth();
  let {appName, objectName, recordUuid} = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const [mutableChart, setMutableChart] = useState<PlotlyChartFigure>(chart)

  useEffect(() => {
  }, [])

  //NOTE: useResizeHandler, autosize=true and responsive=false
  //for proper rendering

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
        marginTop: '1rem',
        borderRadius: 2,
        overflow: 'hidden' //required for proper border radius
      }}
    >
      <Plot
        data={chart.data}
        layout={{...chart.layout,
                autosize: true}}
        config={{...chart.config,
                 responsive: false}}
        useResizeHandler
        style={{ width: '100%',
                 height: '100%'}}
     />
    </Box>
  );

};
